// SubscribeToNewsletter registers the provided email to receive newsletter updates for the provided gender.
export const NewsletterSubscriptionService_SubscribeToNewsletterLazy = () =>
  import("./service.grpc").then(
    (m) => m.NewsletterSubscriptionService_SubscribeToNewsletter
  );
NewsletterSubscriptionService_SubscribeToNewsletterLazy.method =
  "aysa_api.services.newsletter_subscription.v1.NewsletterSubscriptionService/SubscribeToNewsletter" as const;

// UnsubscribeFromNewsletterWith provides an endpoint to unsubscribe from newsletter for a given token and permission.
export const NewsletterSubscriptionService_UnsubscribeFromNewsletterWithTokenLazy =
  () =>
    import("./service.grpc").then(
      (m) => m.NewsletterSubscriptionService_UnsubscribeFromNewsletterWithToken
    );
NewsletterSubscriptionService_UnsubscribeFromNewsletterWithTokenLazy.method =
  "aysa_api.services.newsletter_subscription.v1.NewsletterSubscriptionService/UnsubscribeFromNewsletterWithToken" as const;

// Binds the owner of the user session to a given whatsapp id for future targeting of advertisement
export const NewsletterSubscriptionService_SubscribeToWhatsappNewsletterLazy =
  () =>
    import("./service.grpc").then(
      (m) => m.NewsletterSubscriptionService_SubscribeToWhatsappNewsletter
    );
NewsletterSubscriptionService_SubscribeToWhatsappNewsletterLazy.method =
  "aysa_api.services.newsletter_subscription.v1.NewsletterSubscriptionService/SubscribeToWhatsappNewsletter" as const;

// Subscribe a customer only to the wishlist newsletter
export const NewsletterSubscriptionService_SubscribeToWishlistNewsletterLazy =
  () =>
    import("./service.grpc").then(
      (m) => m.NewsletterSubscriptionService_SubscribeToWishlistNewsletter
    );
NewsletterSubscriptionService_SubscribeToWishlistNewsletterLazy.method =
  "aysa_api.services.newsletter_subscription.v1.NewsletterSubscriptionService/SubscribeToWishlistNewsletter" as const;
